import {
  Table as ChakraTable,
  Th,
  Td,
  TableContainer,
  Thead
} from '@chakra-ui/react';

const tableStyles = {
  px: '4',
  py: '3',
  borderRight: '1px',
  borderColor: 'var(--borderColor)',
  maxWidth: '300px',
  whiteSpace: 'normal'
};

export function Table({ children, ...props }: any) {
  return (
    <TableContainer
      my={6}
      rounded="xl"
      border="1px"
      borderColor="var(--borderColor)"
      boxShadow="md"
      fontFamily="body"
      sx={{
        '& li': {
          my: 1,
          listStyle: 'disc'
        },
        '& ul, ol': {
          listStyleType: 'initial',
          marginInlineStart: '1em'
        },
        '& :not(pre) > code': {
          whiteSpace: 'normal'
        }
      }}
      {...props}
    >
      <ChakraTable
        sx={{
          'tr, td, th': {
            '&:last-child': {
              borderRight: 'none'
            }
          }
        }}
      >
        {children}
      </ChakraTable>
    </TableContainer>
  );
}

export function TableHead({ children, ...props }: any) {
  return (
    <Thead bgColor="var(--tableHead)" {...props}>
      {children}
    </Thead>
  );
}

export function TableHeadingCell({ children, ...props }: any) {
  return (
    <Th
      scope="col"
      fontWeight="bold"
      fontSize="sm"
      textAlign="center"
      {...tableStyles}
      {...props}
    >
      {children}
    </Th>
  );
}

export function TableDataCell({ children, ...props }: any) {
  return (
    <Td {...tableStyles} {...props}>
      {children}
    </Td>
  );
}
